import { withPrefix } from 'gatsby';

const ICON_EMPTY = withPrefix('/icons/favorites/empty-2.svg');
const ICON_FILLED = withPrefix('/icons/favorites/filled.svg');

export const getIcon = isFavorite => (isFavorite ? ICON_FILLED : ICON_EMPTY);
